<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="ma-15">
      <v-card>
        <v-card-title class="primary--text"> Links </v-card-title>
      </v-card>
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left text-uppercase" width="400px"></th>
            <th class="text-left text-uppercase">Link</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-uppercase" widht="200px">
              {{ $t("users.famchart") }} full
            </td>
            <td>{{ dataext.chart_full }}</td>
          </tr>
          <tr>
            <td class="text-uppercase" widht="200px">
              {{ $t("users.famchart") }}  full en
            </td>
            <td>{{ dataext.chart_full_en }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">{{ $t("users.famchart") }} light</td>
            <td>{{ dataext.chart_light }}</td>
          </tr>
          <tr></tr>
          <tr>
            <td class="text-uppercase">Noodplan BV</td>
            <td>{{ dataext.pqs_a }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">Noodplan Personal Holding</td>
            <td>{{ dataext.pqs_b }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-C Basis</td>
            <td>{{ dataext.pqs_c }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-D GRIP</td>
            <td>{{ dataext.pqs_d }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-E Juridische Zaken</td>
            <td>{{ dataext.pqs_e }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-F Standaard Presentatie</td>
            <td>{{ dataext.pqs_f }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-G</td>
            <td>{{ dataext.pqs_g }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-H</td>
            <td>{{ dataext.pqs_h }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-I</td>
            <td>{{ dataext.pqs_i }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PQS-J</td>
            <td>{{ dataext.pqs_j }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-A Noodplan</td>
            <td>{{ dataext.plp_a }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-B {{ $t("users.famchart") }}</td>
            <td>{{ dataext.plp_b }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-C Basis</td>
            <td>{{ dataext.plp_c }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-D GRIP</td>
            <td>{{ dataext.plp_d }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-E Juridische Zaken</td>
            <td>{{ dataext.plp_e }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-F Standaard Presentatie</td>
            <td>{{ dataext.plp_f }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-G</td>
            <td>{{ dataext.plp_g }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-H</td>
            <td>{{ dataext.plp_h }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-I</td>
            <td>{{ dataext.plp_i }}</td>
          </tr>
          <tr>
            <td class="text-uppercase">PLP-J</td>
            <td>{{ dataext.plp_j }}</td>
          </tr>
        </tbody>
      </v-simple-table>

      <FlashMessage :error="error" v-if="error" key="error" />

      <v-col class="text-right">
        <v-btn class="mt-15" color="accent" @click="editItem()">{{
          $t("crud.change")
        }}</v-btn>
      </v-col>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FlashMessage from "@/components/input/FlashMessage";
import LinkService from "@/services/maintain/LinkService";
export default {
  name: "fchartmemberIndex",
  components: { FlashMessage, ToolbarAuth, Navigation },
  data() {
    return {
      loading: false,
      error: null,
      dialogDelete: false,
      itemToDelete: {},
      dataext: {},
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let Id = 1;
      LinkService.getMains(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    editItem() {
      this.$router.push({ name: "linkEdit" });
    },
  },
  computed: {},
  created() {
    this.getData();
  },
  beforeDestroy() {},
};
</script>

<style scoped></style>
